import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/mmt/logo.png";
import prelogin from "../../assets/images/mmt/prelogin.png";
import resetBg from "../../assets/images/mmt/bg-reset-password.png";
import {
  signupMmt,
  verifySignupOtp,
  registerMmt,
  loginMmt,
} from "../mmtUserList/mmtApi";
import { setStoredSession, buildSessionPath } from "../mmtUserList/mmtFlow";
import { ADMIN_CHOICE, USER_LIST } from "../../routes/routerPath";
import { pageLocale } from "../../utlis/locale";
import "./mmtlogin.scss";

const STEPS = {
  EMAIL: "email",
  OTP: "otp",
  REGISTER: "register",
  SUCCESS: "success",
};
const EMAIL_REGEX = /^\s*[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,}\s*$/i;

export default function MmtSignupFlow() {
  const navigate = useNavigate();
  const t = pageLocale("mmtSignup");
  const [step, setStep] = useState(STEPS.EMAIL);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async (fn) => {
    setLoading(true);
    setError("");
    try {
      await fn();
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || t.error_generic);
    } finally {
      setLoading(false);
    }
  };

  const submitEmail = (event) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!EMAIL_REGEX.test(trimmed)) {
      setError(t.error_invalid_email);
      return;
    }
    run(async () => {
      await signupMmt(trimmed);
      setStep(STEPS.OTP);
    });
  };

  const submitOtp = (event) => {
    event.preventDefault();
    if (!/^\d{4,8}$/.test(otp.trim())) {
      setError(t.error_invalid_code);
      return;
    }
    run(async () => {
      await verifySignupOtp(email.trim(), otp.trim());
      setStep(STEPS.REGISTER);
    });
  };

  const submitRegister = (event) => {
    event.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      setError(t.error_missing_name);
      return;
    }
    if (password.length < 8) {
      setError(t.error_password_length);
      return;
    }
    if (password !== confirm) {
      setError(t.error_password_mismatch);
      return;
    }
    run(async () => {
      await registerMmt({
        email: email.trim(),
        password,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
      });
      const { session } = await loginMmt(email.trim(), password);
      setStoredSession(session);
      setStep(STEPS.SUCCESS);
      const target =
        session.role === "ADMIN"
          ? ADMIN_CHOICE
          : buildSessionPath(USER_LIST, session);
      window.setTimeout(() => {
        navigate(target, { replace: true });
      }, 1200);
    });
  };

  return (
    <main className="mmt-login-page">
      <section className="mmt-login-scroll">
        <div className="mmt-login-shell">
          <div className="mmt-login-art">
            <img src={logo} alt="Senior Life" className="mmt-login-logo" />
            <img src={prelogin} alt="" className="mmt-login-prelogin" />
          </div>

          {step === STEPS.EMAIL ? (
            <form className="mmt-login-card" onSubmit={submitEmail}>
              <h1>{t.title}</h1>
              {error ? <div className="mmt-login-error">{error}</div> : null}
              <label className="mmt-field">
                <span>{t.email_label}</span>
                <input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                  }}
                  inputMode="email"
                  autoComplete="email"
                  disabled={loading}
                />
              </label>
              <button
                className="mmt-primary-button"
                type="submit"
                disabled={loading}
              >
                {loading ? t.sending : t.send_code}
              </button>
              <p className="mmt-new-user">
                {t.already_have_account} <Link to="/login">{t.log_in}</Link>
              </p>
            </form>
          ) : null}

          {step === STEPS.OTP ? (
            <form className="mmt-login-card" onSubmit={submitOtp}>
              <h1>{t.verify_email_title}</h1>
              <p>{t.code_sent.replace("{email}", email.trim())}</p>
              {error ? <div className="mmt-login-error">{error}</div> : null}
              <label className="mmt-field">
                <span>{t.code_label}</span>
                <input
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value);
                    setError("");
                  }}
                  inputMode="numeric"
                  disabled={loading}
                />
              </label>
              <button
                className="mmt-primary-button"
                type="submit"
                disabled={loading}
              >
                {loading ? t.verifying : t.verify}
              </button>
            </form>
          ) : null}

          {step === STEPS.REGISTER ? (
            <form className="mmt-login-card" onSubmit={submitRegister}>
              <h1>{t.create_account_title}</h1>
              {error ? <div className="mmt-login-error">{error}</div> : null}
              <label className="mmt-field">
                <span>{t.first_name}</span>
                <input
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  disabled={loading}
                />
              </label>
              <label className="mmt-field">
                <span>{t.last_name}</span>
                <input
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  disabled={loading}
                />
              </label>
              <label className="mmt-field">
                <span>{t.password}</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </label>
              <label className="mmt-field">
                <span>{t.confirm_password}</span>
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  disabled={loading}
                />
              </label>
              <button
                className="mmt-primary-button"
                type="submit"
                disabled={loading}
              >
                {loading ? t.creating : t.create_account}
              </button>
            </form>
          ) : null}

          {step === STEPS.SUCCESS ? (
            <div className="mmt-login-card">
              <h1>{t.welcome_title}</h1>
              <p>{t.welcome_subtitle}</p>
            </div>
          ) : null}
        </div>
      </section>
      <img src={resetBg} alt="" className="mmt-login-bg" />
    </main>
  );
}
